import React from "react";
import '../assets/css/footer.css';
const Footer = () => {
  return (
    <div className="footer fixed-footer">
      <div className="copyright">
        <p>Copyright &copy; Savitar</p>
      </div>
    </div>
  );
};

export default Footer;
